var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2415.74 509.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -192.22,
    y1: -2037.96,
    x2: -76.96,
    y2: -2037.96,
    gradientTransform: "translate(1045.23 2135.53) rotate(-22.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a646e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d955b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f86d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -237.01,
    y1: -2130.67,
    x2: 37.21,
    y2: -2130.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9398.78,
    y1: 4806.78,
    x2: 9514.98,
    y2: 4806.78,
    gradientTransform: "matrix(-0.41, 0.98, -0.66, -0.27, 7401.25, -7921.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -237.05,
    y1: -2027.3,
    x2: 185.91,
    y2: -2027.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -152.23,
    y1: -1929.21,
    x2: 261.28,
    y2: -1929.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 27.25,
    y1: -1887.3,
    x2: 227.09,
    y2: -1887.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 305.29,
    y1: 2164.52,
    x2: 540.41,
    y2: 2164.52,
    gradientTransform: "matrix(1, 0.04, -0.03, 0.59, -17.17, -891.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 241.26,
    y1: -2000.45,
    x2: 305.72,
    y2: -2000.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 10592.97,
    y1: 2657.55,
    x2: 10657.44,
    y2: 2657.55,
    gradientTransform: "translate(7555.46 -7583.57) rotate(118.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 7026.86,
    y1: -7336.61,
    x2: 7116.95,
    y2: -7336.61,
    gradientTransform: "translate(10076.24 2637.7) rotate(-119.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 9096.61,
    y1: 1670.25,
    x2: 9205.46,
    y2: 1670.25,
    gradientTransform: "matrix(-0.14, 0.99, -1.52, -0.22, 4136.69, -8246.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 10536.37,
    y1: -3978.93,
    x2: 10644.16,
    y2: -3978.93,
    gradientTransform: "matrix(-0.92, -0.39, 0.59, -1.42, 12197.82, -1365.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1973.67,
    y1: 803.1,
    x2: 2072.38,
    y2: 803.1,
    gradientTransform: "matrix(1.21, 0.45, -0.54, 1.44, -1590.09, -1956.01)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 148.86,
    cy: 300.34,
    r: 57.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.45,291.19S60.73,85,202.66,112.14c148.86,28.49,60.85,198.44-21.5,119C105.64,158.32,34.45,291.19,34.45,291.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.14,
    y: 102.62,
    width: 38.94,
    height: 158.43,
    transform: "translate(-61.22 52.41) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.14,
    y: 102.62,
    width: 38.94,
    height: 158.43,
    transform: "translate(232.04 18) rotate(67.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.89,
    y: 282.83,
    width: 38.94,
    height: 158.43,
    transform: "translate(153.7 -40.03) rotate(22.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.89,
    y: 282.83,
    width: 38.94,
    height: 158.43,
    transform: "matrix(-0.39, 0.92, -0.92, -0.39, 578.44, 339.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.34,83.62S280,38.84,374.82,123.2c52.68,46.86,88.47-8.9,81-42.46C427.36-46.22,222.34,83.62,222.34,83.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243,62.38A210.62,210.62,0,0,0,165.8,82c2.21-.22,4.42-.43,6.66-.57A161.88,161.88,0,1,1,56.89,345.58c31.09,85.75,100.29,138.9,196,133.17,116.56-7,220.78-101.41,213.8-218S359.54,55.4,243,62.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "242.53 145.62 224.41 106.83 371.04 46.83 389.16 85.62 242.53 145.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.68,475.74c-.09,0-.1.14,0,.15,9.78,1.79,150.39,25.61,230.47-70.56,68.71-91.06,16-135.49,49.62-177.26,26.8-22.73,46.16,28.26,46.16,28.26S559,195.19,509,169.76C461.54,145.58,380,184.62,369.65,274S321.08,463.41,201.68,475.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M526,267S512.13,393,397,392s58.43-49.25,93.71-87.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M469.85,369.79s-110,129.93-224.59,55.09c-25-16.34-13.74-58.67,55-58,45.72.43,51.9,15.67,111.05,16.26C455.1,383.57,469.85,369.79,469.85,369.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 361.03,
    y: 194.42,
    width: 38.94,
    height: 158.43,
    transform: "translate(489.65 -182.15) rotate(67.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 355.77,
    cy: 217.26,
    r: 21.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M486.17,132.26s97.19,14.14,68,113.33C554.18,245.59,624,119.75,486.17,132.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M194.26,462.76S109.87,513,70.05,417.58C70.05,417.58,95.12,559.27,194.26,462.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.93,128.4S167.11-8.81,309.63,14.9C309.63,14.9,123.28-60.62,163.93,128.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M482.53,421.06s-148.2,123.17-340.1-14.3C142.43,406.76,346.8,627.31,482.53,421.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M53.72,349.63S-27.21,176.8,152.53,27.34C152.53,27.34-109.93,168,53.72,349.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M402.05,27.34s105,77.85-62.68,135.39c0,0,174.94-9.45,159-79.17C493.38,61.61,456.77,35.05,402.05,27.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.36,
    cy: 329.51,
    r: 21.68
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1_step_1",
    "data-name": "1_step_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u043F\\u0440\\u043E\\u0437\\u0440\\u0430\\u0447\\u043D\\u043E\\u0435",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.91,83.42v151.8h-42.5V117.46H762.72V235.22H720.43V83.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1009.08,90.25q15.18,6.82,23.42,19.52t8.24,29.81q0,17.14-8.24,29.71t-23.42,19.41q-15.18,6.84-35.78,6.84H946.84v39.68H903.9V83.42h69.4Q993.9,83.42,1009.08,90.25ZM990.64,156q6.72-5.75,6.73-16.38t-6.73-16.48q-6.72-5.85-19.95-5.85H946.84V161.7h23.85Q983.92,161.7,990.64,156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1102,228.07a76.65,76.65,0,0,1-30.14-28.2q-11-18-10.95-40.55t10.95-40.55A76.65,76.65,0,0,1,1102,90.57q19.2-10.18,43.27-10.19t43.26,10.19a76.67,76.67,0,0,1,30.15,28.2q10.93,18,11,40.55t-11,40.55a76.67,76.67,0,0,1-30.15,28.2q-19.18,10.19-43.26,10.19T1102,228.07Zm64.09-30.8A39,39,0,0,0,1180.83,182a46.22,46.22,0,0,0,5.42-22.66,46.22,46.22,0,0,0-5.42-22.66,39,39,0,0,0-14.74-15.29,42.7,42.7,0,0,0-41.64,0,38.91,38.91,0,0,0-14.75,15.29,46.33,46.33,0,0,0-5.42,22.66A46.33,46.33,0,0,0,1109.7,182a38.91,38.91,0,0,0,14.75,15.29,42.7,42.7,0,0,0,41.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1370.37,170.6a35.53,35.53,0,0,1,7.16,21.9A35.05,35.05,0,0,1,1368,217q-9.56,10.41-25.81,15.94a110.46,110.46,0,0,1-35.78,5.53,139.22,139.22,0,0,1-31.34-3.68,133.81,133.81,0,0,1-30.47-11.06l12.8-29.93a95.41,95.41,0,0,0,21.79,7.92,98.33,98.33,0,0,0,22.45,2.71q14.31,0,23.42-4.67t9.11-13.12a10.76,10.76,0,0,0-5.64-10q-5.64-3.25-15.18-3.25h-38.82V142h35.35q8.67,0,13.44-3.47a10.94,10.94,0,0,0,4.77-9.32q0-7.38-7.37-11.39t-19.08-4a81.46,81.46,0,0,0-20.17,2.71,92.77,92.77,0,0,0-20.17,7.7l-12.58-32.53Q1273,79.94,1302.06,80a108.85,108.85,0,0,1,34.59,5.31q15.94,5.31,25.37,15.29a33.25,33.25,0,0,1,9.44,23.64,33.61,33.61,0,0,1-5.53,19,37.73,37.73,0,0,1-15.29,13.12Q1363.21,161.05,1370.37,170.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1514.36,90.25q15.18,6.82,23.43,19.52t8.24,29.81q0,17.14-8.24,29.71t-23.43,19.41q-15.18,6.84-35.78,6.84h-26.45v39.68h-42.94V83.42h69.39Q1499.19,83.42,1514.36,90.25ZM1495.93,156q6.72-5.75,6.72-16.38t-6.72-16.48q-6.72-5.85-20-5.85h-23.85V161.7H1476Q1489.21,161.7,1495.93,156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1670.94,205.73h-64.19l-11.93,29.49H1551l67-151.8h42.28l67.23,151.8h-44.67Zm-12.58-31.66-19.52-48.58-19.51,48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1872.62,83.42v151.8h-42.29V183.61q-17.57,5.85-32.31,5.85-31.87,0-48.68-15.29T1732.53,130V83.42h42.29v41.85q0,29.28,28.62,29.28,15.61,0,26.89-5.21V83.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2058,83.42v151.8H2015.1V176h-58.55v59.2h-42.94V83.42h42.94v57h58.55v-57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2130.36,228.07a76.65,76.65,0,0,1-30.14-28.2q-11-18-11-40.55t11-40.55a76.65,76.65,0,0,1,30.14-28.2q19.2-10.18,43.26-10.19t43.27,10.19a76.65,76.65,0,0,1,30.14,28.2q10.95,18,10.95,40.55T2247,199.87a76.65,76.65,0,0,1-30.14,28.2q-19.2,10.19-43.27,10.19T2130.36,228.07Zm64.08-30.8A39,39,0,0,0,2209.19,182a46.33,46.33,0,0,0,5.42-22.66,46.33,46.33,0,0,0-5.42-22.66,39,39,0,0,0-14.75-15.29,42.68,42.68,0,0,0-41.63,0,38.91,38.91,0,0,0-14.75,15.29,46.22,46.22,0,0,0-5.42,22.66,46.22,46.22,0,0,0,5.42,22.66,38.91,38.91,0,0,0,14.75,15.29,42.68,42.68,0,0,0,41.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2411.3,202v33.18H2289.43V83.42h119.06V116.6h-76.56v25.59h67.45v32.09h-67.45V202Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u043F\\u0440\\u043E\\u0435\\u043A\\u0442\\u0438\\u0440\\u043E\\u0432\\u0430\\u043D\\u0438\\u0435",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730,423.79H719.41V298.39h99.78v125.4H808.62V308.6H730Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M850.19,298.39h41.2q52.85,0,52.85,39.77,0,40-52.85,39.95H860.76v45.68H850.19Zm83.3,39.77q0-16.47-11.2-23t-30.36-6.54h-31v59.3h31Q933.48,367.9,933.49,338.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M959.47,384.65a69.27,69.27,0,0,1,0-47.12,67,67,0,0,1,12-20.69A55.59,55.59,0,0,1,992.07,302a75.87,75.87,0,0,1,57,0,55.68,55.68,0,0,1,20.6,14.87,67.45,67.45,0,0,1,12,20.69,69.42,69.42,0,0,1,0,47.12,67.33,67.33,0,0,1-12,20.69,55.56,55.56,0,0,1-20.6,14.87,75.75,75.75,0,0,1-57,0,55.48,55.48,0,0,1-20.6-14.87A66.93,66.93,0,0,1,959.47,384.65Zm109.81,2.69a62.87,62.87,0,0,0,0-52.49q-5.73-12.09-18.45-20.25t-30.28-8.15q-17.55,0-30.27,8.15t-18.45,20.25a62.87,62.87,0,0,0,0,52.49q5.73,12.09,18.45,20.24t30.27,8.15q17.57,0,30.28-8.15T1069.28,387.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1108,298.39h83.3V308.6h-72.73v46.94h67.36v10.21h-67.36v47.83h74v10.21H1108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1225.68,423.79h-10.57V298.39h10.57v56.25h32.78L1299,298.39h12.18l-43.89,61.09,48.19,64.31h-12.36l-44.25-59.11h-33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1314.71,298.39H1417V308.6h-45.86V423.79h-10.57V308.6h-45.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1535.6,423.79H1525V316.31L1442.8,423.79h-9.67V298.39h10.57V405.7l82.22-107.31h9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1566.59,298.39h41.2q52.85,0,52.85,39.77,0,40-52.85,39.95h-30.63v45.68h-10.57Zm83.3,39.77q0-16.47-11.19-23t-30.37-6.54h-31v59.3h31Q1649.9,367.9,1649.89,338.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1675.87,384.65a69.42,69.42,0,0,1,0-47.12,67,67,0,0,1,12-20.69,55.68,55.68,0,0,1,20.6-14.87,75.87,75.87,0,0,1,57,0,55.71,55.71,0,0,1,20.61,14.87,67.45,67.45,0,0,1,12,20.69,69.42,69.42,0,0,1,0,47.12,67.33,67.33,0,0,1-12,20.69,55.6,55.6,0,0,1-20.61,14.87,75.75,75.75,0,0,1-57,0,55.56,55.56,0,0,1-20.6-14.87A66.93,66.93,0,0,1,1675.87,384.65Zm109.82,2.69a63,63,0,0,0,0-52.49q-5.75-12.09-18.46-20.25T1737,306.45q-17.57,0-30.28,8.15t-18.45,20.25a63,63,0,0,0,0,52.49q5.73,12.09,18.45,20.24t30.28,8.15q17.55,0,30.27-8.15T1785.69,387.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1824.38,298.39h48.73q19.71,0,31.08,8t11.38,23.56q0,11.65-6.54,18.72a30.49,30.49,0,0,1-16,9.23,39.83,39.83,0,0,1,19.26,9.85q8.16,7.53,8.33,22a31.86,31.86,0,0,1-3.22,14.6,28.12,28.12,0,0,1-8,9.94,39.93,39.93,0,0,1-11.38,5.82,63.19,63.19,0,0,1-12.36,3,97.86,97.86,0,0,1-12.18.71h-49.09Zm80.44,33q0-22.74-32.43-22.75h-37.26v45h42.46q11.64,0,19.44-5.47T1904.82,331.35Zm5,57.33q0-25.08-33.14-25.08h-41.56v50h36.37c4.18,0,7.76-.11,10.75-.35a59.58,59.58,0,0,0,10-1.8,27.81,27.81,0,0,0,9.13-3.94,19.25,19.25,0,0,0,6-7.34A25.43,25.43,0,0,0,1909.83,388.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1936.35,423.79h-11.47l55.9-125.4h12l55.71,125.4H2037l-14.87-33.68H1951.4Zm48.73-110.53-29.56,66.82h62.34l-29.56-66.82c-.36-.95-.89-2.27-1.61-3.94C1986,311,1985.43,312.31,1985.08,313.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2156.16,298.39h10.57v125.4h-10.57V365.93h-81.33v57.86h-10.57V298.39h10.57v57.33h81.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2300.2,423.79h-10.57V316.31L2207.4,423.79h-9.68V298.39h10.57V405.7l82.23-107.31h9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2331.19,298.39h83.3V308.6h-72.73v46.94h67.36v10.21h-67.36v47.83h74v10.21h-84.55Z"
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7217f4612e88d9a2d68cdff6f9c9e27d.svg";
export { ForwardRef as ReactComponent };